import React, { useState, useEffect, useContext, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import PaymentFun from "Components/Profile/Payment/PaymentFun";
import './ImageSilder.css';
import MysteryBoxInfo from "./MysteryBoxInfo";
import AppContext from "Contexts/AppContext";
import Cart from '../../assets/svg/Cart.svg';
import GoldenMysteryBoxInfo from "./GoldenMysteryBoxInfo";
import { showToast } from "App";
import { ToastType } from "Contexts/Notification";
import UserContext from "Contexts/User";
import axios from "axios";
import { SampleNextArrow } from "./ImageSilder";
import { SamplePrevArrow } from "./ImageSilder";
import Slider from "react-slick";
const Wrapper = styled.div`
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  width:${window.screen.width > 767 ?"65%":"97%"};   
  
  margin:40px auto;   
  @media (max-width: 767px) {
    margin:0px auto;   
  }
`;

const Icon3 = styled.i`
  border-radius: 50%;
  font-size: 13px;  
  font-weight: 300;  
  text-align: center;
`;
const ButtonAddSub = styled.button`
  color:white;
  background-color:transparent;
  border:1px solid white;
  padding:5px 10px;
  border-radius:5px;
  :hover{
    background-color:white;
    color:black;
  }
`;


const Title = styled.span`
  color: #FFD700;
  font-size:${window.screen.width > 767 ?"16px":"16px"};
  font-weight:100;  
`;

const Box = styled.div`  
  border-radius: 10px;
  padding: ${window.screen.width > 767 ? "" : "1rem"};  
  overflow: hidden;
  width: 100%;
  height: 400px;
  @media (max-width: 767px) {
     height: 320px; /* Set a fixed height for mobile */
  }
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000; /* optional background to show padding gap */
  
  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    border: 2px solid #fff; /* ✅ border directly on the image */
    border-radius: 10px;
  }
`;




const SideText = styled.div`
  p{
  padding:5px 0px;
  }
  position: relative;
  @media (min-width: 768px) {
    margin-left: 50px;
  }
`;

type BuyCardDataProps = { setQuantityValue: any };

const BuyCardData: React.FC<BuyCardDataProps> = ({ setQuantityValue }) => {  
  const [quantity, setQuantity] = useState(1);  
  const [showInfoData, setShowInfoData] = useState(false);    

  const [allProducts, setAllProducts] = useState([]);
  const {buyProduct,setBuyProduct} = useContext(AppContext);
  
      
  const sliderRef = useRef<Slider>(null);

  const handleAfterChange = (index:number) => {    
    setBuyProduct(allProducts[index]);
    setQuantityValue(1);
    setQuantity(1);   
    // totalPriceValue(buyProduct?.priceUsd);
  };  

  
  useEffect(() => {
    if (sliderRef.current) {
      if (allProducts?.length > 0 && buyProduct && buyProduct?.id) {      
        const idx = allProducts.findIndex((p:any) => p.id === buyProduct.id);
        console.log(idx,"initialSlideidx")
        if (idx !== -1) {
          sliderRef.current.slickGoTo(idx);
        }else{
          sliderRef.current.slickGoTo(0);
        }

      }       
    }
  }, [allProducts]);
  
  useEffect(()=>{
    axios.get(`${process.env.REACT_APP_V2E}getAllProductsFromDatabase`).then((res:any)=>{
      setAllProducts(res?.data?.data)
    }).catch((err:any)=>{
      console.log(err)
    })    
  },[])

  const settings = {
    // dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow:<SampleNextArrow />,
    prevArrow:<SamplePrevArrow />,
    afterChange: handleAfterChange,
    // initialSlide: initialSlide,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 1, slidesToScroll: 1}
      },
      {
        breakpoint: 600,
        settings: {  slidesToShow: 1, slidesToScroll: 1, }
      },
      {
        breakpoint: 480,
        settings: {  slidesToShow: 1, slidesToScroll: 1,}
      }
    ]
  };


  // When allProducts or buyProduct changes, set initialSlide and currentIndex



  const navigate = useNavigate();
  
useEffect(() => {
  if(Object.keys(buyProduct).length === 0)navigate("/buyget")  
 }, []);

// useEffect(() => {
//   if (allProducts.length > 0) {
//     setBuyProduct(allProducts[0]);
//   }
// }, [allProducts]);


  const handleQuantityChange = (delta: number) => {
    if (!buyProduct) return;
  
    const remaining = buyProduct.remaining ?? Infinity;
  
    setQuantity((prev) => {
      const newVal = prev + delta;
  
      if (newVal < 1) return 1;
      if (newVal > remaining) {
        // alert(`Only ${remaining} items available`);
        showToast(`Only ${remaining} Card Remaining`, ToastType.ERROR);        
        return remaining;
      }
      setQuantityValue(newVal);
        // totalPriceValue(newVal * buyProduct?.priceUsd);
      return newVal;
    });
  };
  
  const totalPrice = quantity * buyProduct?.priceUsd;
  
  useEffect(() => {
    let price = totalPrice
    let payvalue = [price,"PRODUCT_PURCHASE",0, 0,buyProduct?.id]
    // let payvalue = [0.000001,"PRODUCT_PURCHASE",0, 0,index+1]
    let PayValuestring = JSON.stringify(payvalue)
    localStorage.setItem("PayAmount", PayValuestring);
  }, [totalPrice,quantity])
  const MysteryBox = ["Mystery Box", "Gold Mystery Box"].includes(buyProduct?.name)
  return (
   <>
    <div className="slider-container">
    <Slider ref={sliderRef} {...settings}>
    {allProducts.sort((a:any, b:any) => a.id - b.id).map((item:any, index) => (
    <Wrapper key={item.id}>
      <div className="container">
        <div className="row align-items-center justify-content-center">
          {/* Left Side */}
          <div className="col-md-5 order-2 order-md-1 mb-4 mb-md-0">                      
          <SideText className="mt-4">
            <div className="d-flex align-items-center justify-content-start">
               <p className='fs-6 fw-lighter'>Name <Title>{item?.name.toUpperCase()}</Title></p>              
                {MysteryBox &&<button className="more-details-btn"
                onClick={() => setShowInfoData(!showInfoData)}>
                      <span className="left-arrow" />
                      More details
                </button>}  
                {showInfoData && item?.name=="Mystery Box" && <MysteryBoxInfo onClose={() => setShowInfoData(false)} />}              
                {showInfoData && item?.name=="Gold Mystery Box" && <GoldenMysteryBoxInfo onClose={() => setShowInfoData(false)} />}              
            </div>
              {["Mystery Box", "Gold Mystery Box"].includes(item?.name)?"":<p className='fs-6 fw-lighter'>Rarity <Title>{item?.rarity}</Title></p>}
              <p className='fs-6 fw-lighter'>
                Total Supply {(item?.totalSupply)?.toLocaleString()} | Remaining {(item?.remaining + item?.goldMysteryBox || 0 + item?.mysteryBox|| 0 )?.toLocaleString()}
              </p>
              <p className='fs-6 fw-lighter'>
                Pay ${item?.priceUsd?.toLocaleString()} &nbsp;
              </p>  
              <p className='fs-6 fw-lighter'>
                Get {MysteryBox && "Up to "}<Title>{(item?.vCoin)?.toLocaleString()} Vcoins</Title> | {MysteryBox && "Up to "} <Title>{(item?.vCoinX2)?.toLocaleString()}</Title> with Social Boost
              </p>                                       
              <div className="d-flex align-items-center justify-content-start mt-2">            
              </div>
            </SideText>            
            {item?.remaining > 0 && (
              <div className="d-flex align-items-center justify-content-start ms-md-5">
                <img src={Cart} alt="Cart" width={30} height={30}/>
                <div className="d-flex align-items-center justify-content-start gap-2 ms-4 ">
                  <ButtonAddSub
                    onClick={() => handleQuantityChange(-1)}
                    onMouseDown={(e) => e.preventDefault()}                   
                  >
                    -
                  </ButtonAddSub>
                  <span className="bg-white text-black px-3 py-2 rounded">{quantity}</span>
                  <ButtonAddSub                                
                    onClick={() => handleQuantityChange(1)}
                    onMouseDown={(e) => e.preventDefault()}                   
                  >
                    +
                  </ButtonAddSub>              
                </div>
                  <Title className="text-warning fw-bold">
                    Total ${totalPrice?.toLocaleString()}
                  </Title>
              </div>
            )}            

          </div>

          {/* Right Side */}
          <div className="col-md-5 order-1 order-md-2">
            <Box>
              <img
                src={item?.image_link}
                alt="Vcoin x2 Promo"
              />
            </Box>
          </div>
        </div>
      </div>
    </Wrapper>   
    ))}
    </Slider>
    </div>   
   </>
  );
};

export default BuyCardData;
